<!-- 页面右侧试题选项列表-->
<template>
  <div class="problem-controler-wrapper c-pd-ProblemControler">
    <div class="problem-controler-content" v-if="answerList">
      全部共{{selectData.length}}道试题（简答题不计入正确率）
      <div class="drill">
        <el-radio-group v-model="radio">
          <el-radio :label="1">全部试题</el-radio>
          <el-radio :label="2">只看错题</el-radio>
          <el-radio :label="3">只看对题</el-radio>
        </el-radio-group>
      </div>
      <div class="answer_box">
        <div :key="index" class="problem-controler-single" v-for="(item, index) in answerList">
          <div class="answer_li" v-if="item.child.length > 0">
            <span>{{item.name}}</span>
            <span>共（{{ item.child.length }}）题</span>
            <section>
              <a
                :class="{ active: isActive === itm.examinationItemId }"
                :key="idx"
                :style="itm.isCorrect?'color: #89BEFF;background-color:#E0F2FF':
                (!itm.isCorrect?'color: #FF4B60;background-color:#FFECF0': '')"
                @click="onClick(itm, itm.order, itm.order_size)"
                class="common-trans"
                v-for="(itm, idx) in item.child"
              >{{ itm.order }}</a>
            </section>
          </div>
        </div>
        <div class="nomore">没有更多试题了</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'problemControlers',
  props: ['selectData', 'is_submits', 'selectCount', 'type', 'count',],
  data () {
    return {
      isActive: '',
      is_active: true,
      radio: 1
    }
  },
  watch: {
    is_submits (val) {
      this.is_submit = val
    }
  },
  filters: {
    filterTime (val) {
      if (val < 10) {
        return '0' + val
      } else {
        return val
      }
    }
  },
  computed: {
    answerList () {
      let answerList = [
        {
          name: '单选题',
          child: []
        },
        {
          name: '多选题',
          child: []
        },
        {
          name: '判断题',
          child: []
        },
        {
          name: '简答题',
          child: []
        }
      ]
      if (this.radio === 1) {
        for (let i = 0; i < this.selectData.length; i++) {
          if (Number(this.selectData[i].questionType) === 1) {
            answerList[0].child.push(this.selectData[i])
          } else if (Number(this.selectData[i].questionType) === 2) {
            answerList[1].child.push(this.selectData[i])
          } else if (Number(this.selectData[i].questionType) === 3) {
            answerList[2].child.push(this.selectData[i])
          } else if (Number(this.selectData[i].questionType) === 4) {
            answerList[3].child.push(this.selectData[i])
          }
        }
      } else if (this.radio === 2) {
        for (let i = 0; i < this.selectData.length; i++) {
          if (
            Number(this.selectData[i].questionType) === 1 &&
            this.selectData[i].questionAnswer !== this.selectData[i].select
          ) {
            answerList[0].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 2 &&
            this.selectData[i].questionAnswer !== this.selectData[i].select
          ) {
            answerList[1].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 3 &&
            this.selectData[i].questionAnswer !== this.selectData[i].select
          ) {
            answerList[2].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 4 &&
            this.selectData[i].questionAnswer !== this.selectData[i].select
          ) {
            answerList[3].child.push(this.selectData[i])
          }
        }
      } else if (this.radio === 3) {
        for (let i = 0; i < this.selectData.length; i++) {
          if (
            Number(this.selectData[i].questionType) === 1 &&
            this.selectData[i].questionAnswer === this.selectData[i].select
          ) {
            answerList[0].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 2 &&
            this.selectData[i].questionAnswer === this.selectData[i].select
          ) {
            answerList[1].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 3 &&
            this.selectData[i].questionAnswer === this.selectData[i].select
          ) {
            answerList[2].child.push(this.selectData[i])
          } else if (
            Number(this.selectData[i].questionType) === 4 &&
            this.selectData[i].questionAnswer === this.selectData[i].select
          ) {
            answerList[3].child.push(this.selectData[i])
          }
        }
      }
      return answerList
    },
  },
  mounted () {
    setTimeout(() => {
      if (Number(this.type) === 2) {
        this.timeOut = setInterval(() => {
          this.num++
          sessionStorage.setItem('num', this.num)
        }, 1000)
      }
    }, 200)
  },
  methods: {
    onClick (item, index) {
      this.isActive = item.examinationItemId
      let active_an = {
        active: '#parsing' + index,
        index
      }
      this.$addStorageEvent(0, 'active_an', JSON.stringify(active_an))
    },
    getBannk (i) {
      if (i > 0) {
        this.$emit('setBankList', 1)
        this.is_active = false
      } else {
        this.is_active = true
        this.$emit('setBankList', 0)
      }
    }

  },
  destroyed () {
    clearInterval(this.timeOut)
    sessionStorage.setItem('num', 0)
  }
}
</script>
<style lang="less" scoped>
.c-pd-ProblemControler {
  @color: #36abff;
  .problem-controler-content {
    text-align: center;
    margin-top: 52px;
    .tiemOut {
      display: flex;
      align-items: flex-start;
      color: #222222;
      font-size: 1rem;
      border-bottom: 1px solid #f0f1f2;
      margin-bottom: 0.5rem;
      align-items: center;
      height: 120px;
      justify-content: center;
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(71, 162, 255, 1);
      line-height: 35px;
      img {
        width: 1.5625rem;
        height: 1.5625rem;
        margin-top: 0.1rem;
        margin-right: 10px;
      }
    }
    .answer_box {
      width: 100%;
      height: 35.625rem;
      overflow-y: auto;
      margin-top: 20px;
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        /**/
      }
      &::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
      }
      .answer_tab {
        display: flex;
        color: #222;
        font-size: 1rem;
        margin-bottom: 2rem;
        div {
          width: 50%;
          display: inline-flex;
          justify-content: center;
          span {
            padding: 0.75rem 0;
            display: inline-block;
          }
        }
        .all,
        .allFalse {
          .active {
            color: #36abff !important;
            border-bottom: 0.125rem solid #36abff;
          }
        }
      }
      .problem-controler-single {
        padding: 0.25rem 1.5rem 1.75rem 1.5rem;
        section {
          list-style: none;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          a {
            color: #222222;
            width: 2.875rem;
            height: 2.875rem;
            border-radius: 50%;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            margin-right: 7%;
            font-size: 0.8rem;
            margin-top: 0.6rem;
            border: 1px solid #f5f5f5;
            &:hover {
              cursor: pointer;
              color: @color;
              border-color: @color;
            }
            // &:nth-child(5n+5) {
            //   margin-right: 0;
            // }
          }
          .active {
            color: #fff !important;
            border-color: @color;
            background-color: @color !important;
            a:hover,
            &:hover {
              color: #fff;
            }
          }
        }
      }
    }
    .footer {
      width: 100%;
      display: flex;
      margin-top: 30px;
      .commit-btn {
        color: #fff;
        outline: none;
        border: 0;
        width: 98px;
        height: 36px;
        background: linear-gradient(
          90deg,
          rgba(77, 205, 253, 1),
          rgba(71, 162, 255, 1)
        );
        border-radius: 4px;
        &:disabled {
          background-color: #bfbfbf;
        }
        cursor: pointer;
        &:focus {
          outline: none;
        }
        &:active {
          outline: none;
        }
      }
    }
  }
}
.drill {
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 4px solid #f2f2f2;
  margin-top: 32px;
}
.nomore {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(187, 187, 187, 1);
  line-height: 22px;
  text-align: center;
}
.reanswer {
  outline: none;
  border: 0;
  width: 98px;
  height: 36px;
  background: #ffffff;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
  cursor: pointer;
}
</style>